import './App.css';
import Input from './Components/Input';


function App() {
  return (
    <>
      <Input/>
    </>
  );
}

export default App;
